<template>
    <div>
        <Cell center style="height: 110px;margin-bottom: 5px;">
            <div class="body">
                <div class="content">
                    <div class="flex-center-y center">
                        <img :src="downloadImg + taskDevice.productImage1" style="height: 65px;width: 65px;background:#aaa;"/>
                        <div class="name" style=" padding: 6px;">
                            <div>{{taskDevice.productName}}</div>
                            <div>{{taskDevice.productModel}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="extra" >
                <Icon  name="delete" size="20" color="red" style="display: flex;justify-content: flex-end;margin-bottom: 18px;" @click="deleteDevice"/>
                <Stepper  v-model="taskDevice.count"  @plus="plusCount"  @minus="minusCount"/>
            </div>
        </Cell>
    </div>
</template>

<script>
    import {downloadImg} from "@/config"
    import {Stepper, Icon, Dialog, Cell} from "vant"


    export default {
        components: {Cell, Stepper, Icon, Dialog},
        props: {
            taskDevice: {type: Object, required: true}
        },
        data() {
            return {
                taskId: this.$route.params.id,
                downloadImg,
            };
        },
        computed: {},
        created() {
        },
        mounted() {

        },
        methods: {
            plusCount() {
                 this.$http.tokiot.prospect.taskDevice.submit({
                    taskId: this.taskId,
                    productId: this.taskDevice.productId,
                    count: this.taskDevice.count + 1
                })
                    .then(res => {
                        if (res) {
                            this.$emit("onRefresh")
                        }
                    })
            },
            minusCount(){
                this.$http.tokiot.prospect.taskDevice.submit({
                    taskId: this.taskId,
                    productId:this.taskDevice.productId,
                    count: this.taskDevice.count-1
                })
                    .then(res => {
                        if (res) {
                            this.$emit("onRefresh")
                        }
                    })
            },
            deleteDevice() {
                Dialog.confirm({
                    message: "确定删除吗",
                }).then(() => {
                    this.$toast.loading("正在处理中");
                    this.$http.tokiot.prospect.taskDevice.delete({id: this.taskDevice.id})
                        .then(res => {
                            this.$toast.clear();
                            if (res) {
                                this.$toast.success("删除成功");
                                this.$emit("onRefresh")
                            }
                        })
                })
            }
        },
        watch: {}
    };
</script>

<style lang="less" scoped>
    & > .body {
        display: flex;
        &>.right{
            width: 25px;
            color: #1890ff;
            font-size: 20px;
            font-weight: 500;
        }
        & > .content {
            padding: 8px;
            width: 100%;
            & > .center {
                padding: 5px;
                display: flex;
                & > img {
                    width: 60px;
                    height: 60px;
                    background: #cccccc;
                    border-radius: 8px;
                }
                & > .name {
                    padding-left: 25px;
                    height: 100%;
                    display: flex;
                    flex-direction: column;

                    & > div {
                        line-height: 1.5;
                    }
                }
            }
        }
    }
</style>

